import reducer from '../utils/reducer'
import { ACTION_NAMES } from '../utils/actionConstants'

const initialState = {
  loading: true
}

export default reducer(initialState, {
    [ACTION_NAMES.STATIC_CONTENT.UNLOAD_STATIC_CONTENT]: (state, payload) => {
      return initialState
    },
    [ACTION_NAMES.STATIC_CONTENT.REQUEST_STATIC_CONTENT]: (state, payload) => {
      return state
    },
    [ACTION_NAMES.STATIC_CONTENT.RECEIVE_STATIC_CONTENT]: (state, payload) => {
      return {
        ...payload,
        loading: false
      }
    }
  })
  